











































import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { useDropdown } from '@/features/dropdown';
import { AggregationOption } from '~/graphql-types.gen';
import { CONFIG_STORE_CURRENCY } from '~/utils/provides';

export default defineComponent({
  name: 'FacetDropdown',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'select',
    },
  },
  setup(props, { emit }) {
    const currencyCode = inject(CONFIG_STORE_CURRENCY);
    const { isOpen, toggle } = useDropdown();

    const selectedOptions = computed(() =>
      Array.isArray(props.value) ? props.value : [props.value].filter(val => val ?? false)
    );

    const selectedLabel = computed(() => {
      if (props.type !== 'price') {
        return selectedOptions.value.map(curr => curr.label).join(',');
      }

      // Skip including price if it already has the value of the existing min/max range.
      if (selectedOptions.value.toString() === props.options.toString()) {
        return '';
      }

      if (props.type === 'price' && selectedOptions.value.toString().split(',').length) {
        return `${selectedOptions.value.toString().split(',')[0]} ${currencyCode?.value} - ${
          selectedOptions.value.toString().split(',')[1]
        } ${currencyCode?.value} `;
      }
      return '1';
    });

    /** * called when a new facet option is selected / deselected * handles emitting the new values to the parent component
(category page) */
    function updateFacet(newValue: AggregationOption) {
      emit('input', newValue);
    }

    return {
      isOpen,
      toggle,
      selectedOptions,
      selectedLabel,
      updateFacet,
    };
  },
});
